import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormArray,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { SwitchWebhookService } from 'src/app/_services/switch-webhook.service';
import { UserService } from 'src/app/_services';
import { DialogService } from 'primeng/dynamicdialog';
import { SwitchWebhookDialogComponent } from '../switch-webhook-dialog/switch-webhook-dialog.component';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-switch-webhook-client',
  templateUrl: './switch-webhook-client.component.html',
  styleUrls: ['./switch-webhook-client.component.scss'],
})
export class SwitchWebhookClientComponent implements OnInit {
  webhooks: any[] = [];
  user: any;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private switchWebhookService: SwitchWebhookService,
    private userService: UserService,
    private dialogService: DialogService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.user = this.userService.currentUser;
    this.loading = true;

    this.switchWebhookService.getWebhooksByUserId(this.user.id).subscribe({
      next: (data: any) => {
        this.webhooks = data.body;
      },
      error: (error) => {
        this.loading = false;
        console.error('Error fetching webhooks:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openDialog(webhook: any) {
    const ref = this.dialogService.open(SwitchWebhookDialogComponent, {
      width: '70%',
      data: webhook,
    });
  
    ref.onClose.subscribe((result) => {
    });
  }

}
